import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import {
  ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_REQUEST,
  FETCH_CALIX_NETWORKS_CUSTOMER_LIST_REQUEST,
} from "./actionTypes";
import {
  addUpdateCalixNetworksCustomerFailure,
  addUpdateCalixNetworksCustomerSuccess,
  fetchCalixNetworksCustomerListFailure,
  fetchCalixNetworksCustomerListSuccess,
} from "./actions";
import { CalixNetworksCustomers } from "./types";
import { loadState } from "library/helpers/sessionStorage";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* fetchCalixNetworksCustomerListSaga(action: any) {
  try {
    const response: CalixNetworksCustomers[] = yield call(
      postRequest,
      action.url,
      action.payload,
    );
    const totalCount =
      response && response.length > 0 && response[0]?.totalCount
        ? response[0].totalCount
        : 0;
    yield put(fetchCalixNetworksCustomerListSuccess(response, totalCount));
  } catch (error: any) {
    yield put(fetchCalixNetworksCustomerListFailure(getErrorMessageString(error)));
  }
}

function* addUpdateCalixNetworksCustomerSaga(action: any) {
  try {
    const response: { status: string; message: string } = yield call(
      postRequest,
      action.url,
      action.payload,
    );
    yield put(addUpdateCalixNetworksCustomerSuccess(response.message));
    action.callback("Success", response.message);
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(addUpdateCalixNetworksCustomerFailure(errorMessage));
    action.callback("Error", errorMessage);
  }
}

export default function* calixNetworksSaga() {
  yield takeLatest(
    FETCH_CALIX_NETWORKS_CUSTOMER_LIST_REQUEST,
    fetchCalixNetworksCustomerListSaga,
  );
  yield takeLatest(
    ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_REQUEST,
    addUpdateCalixNetworksCustomerSaga,
  );
}
